import { AppAction } from '@om-fe/store';
export const TOP_BETS_SPORT_WITH_LOCATION_PATH: string = 'next-locations-by-popularity-with-live/:disciplineId';
export const TOP_BETS_SPORT_WITH_CATEGORY_PATH: string = 'next-categories-by-popularity-with-live/:disciplineId';
export const TOP_BETS_SPORT_WITH_LOCATION_PATH_AND_TIMEZONE: string = 'next-locations-by-popularity-with-live/:disciplineId/:offsetTime';
export const TOP_BETS_SPORT_WITH_CATEGORY_PATH_AND_TIMEZONE: string = 'next-categories-by-popularity-with-live/:disciplineId/:offsetTime';
export const TOP_BETS_SPORT_WITH_CHILDREN_PATH: string = 'next-sport-children-by-popularity-with-live/:disciplineId';

export const slicePrefix = `top-bets-second-nav`;

export enum TopBetsActions {
    SetLoadingData = 'sports:top-bets:set-loading-data',
    SetFilterData = 'sports:top-bets:set-top-bets-filter-data',
}

export interface TopBetsSetLoadingData extends AppAction<TopBetsActions.SetLoadingData> {
    readonly meta: {
        readonly slice: string;
    };
    readonly payload: {
        readonly isLoadingData: boolean;
    };
}

export interface TopBetsSetFilterDataAction extends AppAction<TopBetsActions.SetFilterData> {
    readonly meta: {
        readonly slice: string;
    };
    readonly payload: {
        readonly disciplineId: string;
        readonly isCategory?: boolean;
    };
}

export interface TopBetsTopic {
    readonly path: string;
    readonly params: {
        readonly disciplineId: string;
        readonly isCategory?: boolean;
        readonly offsetTime?: string;
    };
}


export interface TopBetsStoreModel {
    readonly ready: boolean;
    readonly isLoadingMoreData: boolean;
    readonly isLoadingData: boolean;
    readonly disciplineId?: string;
    readonly locationId?: string;
    readonly isDefault?: boolean;
    readonly mainMarketsLimit?: number;
    readonly limit: number;
    readonly totalRecords: number;
    readonly eventCategoryId?: string;
    readonly marketGroupsOverviewNumber?: number;
    readonly marketGroupsOverviewIds?: string;
}